import { createKeyDownFilter, isPasteShortcut } from './keyboard';

const handleCheckKey = (
  event: React.KeyboardEvent<HTMLInputElement>,
  regex: RegExp,
  callback?: (value: boolean) => void
) => {
  callback?.(false);

  const filter = createKeyDownFilter(regex, {
    onInvalid: () => callback?.(true),
  });

  // Maintain explicit paste allowance behavior
  if (isPasteShortcut(event)) {
    return;
  }

  filter(event);
};

/**
 * Handles the key press event for an email input field.
 *
 * This function checks if the pressed key matches the allowed characters
 * for an email address, which includes English letters, numbers, and
 * special characters such as @, ., !, #, $, %, &, ', *, +, -, /, =, ?, ^, _, `, {, |, }, and ~.
 *
 * @param event - The keyboard event triggered by the user's key press.
 */
export const handleCheckKeyForMail = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const mailRegex = /^[a-zA-Z0-9@.-_]*$/; // Only allows English letters and numbers
  handleCheckKey(event, mailRegex);
};

/**
 * Handles the key press event for input fields, allowing only English letters and numbers.
 *
 * @param event - The keyboard event triggered by the user's key press.
 */
export const handleCheckKeyFields = (
  event: React.KeyboardEvent<HTMLInputElement>,
  callback?: (value: boolean) => void
) => {
  const fieldsRegex = /^[a-zA-Z0-9]*$/; // Only allows English letters and numbers
  handleCheckKey(event, fieldsRegex, callback);
};

export const handleCheckKeyFieldsForAz = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const fieldsRegex = /^[a-zA-ZəƏıIöÖüÜğĞşŞçÇ]*$/; // Only allows English and AZ letters and numbers
  handleCheckKey(event, fieldsRegex);
};

export const handleCheckKeyFieldsForAzAndNumbers = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const fieldsRegex = /^[a-zA-Z0-9əƏıIöÖüÜğĞşŞçÇ]*$/; // Only allows English and AZ letters and numbers
  handleCheckKey(event, fieldsRegex);
};
